<template>
  <div v-bem="{ bordered, centered }">
    <div v-bem:header.flow="{ flow }">
      <h2 v-bem:title v-text="title" />
      <p v-if="subtitle" v-bem:subtitle v-text="subtitle" />
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'FieldGroup',
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: undefined,
    },
    flow: {
      type: Boolean,
      default: false,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    centered: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@use '~tokens/sass/utils';
@use "sass:map";

.field-group {
  @at-root & + & {
    // margin-top: 2rem;

    @at-root #{&}__header {
      padding-bottom: 0rem;
    }
  }

  @at-root #{&}__header {
    padding-bottom: utils.f-convert-to-rem(40);

    @include utils.bs-media-breakpoint-up(md) {
      padding-bottom: utils.f-convert-to-rem(32);
    }

    & > * {
      margin-top: 0;
      margin-bottom: 0;

      & + * {
        margin-top: utils.f-rem-calc(12);
      }
    }

    @at-root #{&}--flow {
      padding-top: utils.f-convert-to-rem(30);
      padding-bottom: 0;
    }
  }

  @at-root #{&}--bordered #{&}__header {
    @include utils.bs-media-breakpoint-down(md) {
      margin-right: utils.f-rem-calc(utils.$v-wizard-sm-gap-x * -1);
      margin-left: utils.f-rem-calc(utils.$v-wizard-sm-gap-x * -1);
      margin-bottom: utils.f-convert-to-rem(20);
      padding-right: utils.f-rem-calc(utils.$v-wizard-sm-gap-x);
      padding-left: utils.f-rem-calc(utils.$v-wizard-sm-gap-x);
      padding-bottom: utils.f-convert-to-rem(20);
      border-bottom: 1px solid map.get(utils.$v-colors, rw-grey-01);
    }
  }

  @at-root #{&}--centered #{&}__header {
    text-align: center;
  }

  @at-root #{&}__title {
    font-size: utils.f-rem-calc(20);
    margin-bottom: utils.f-convert-to-rem(16);
    max-width: 590px;
  }

  @at-root #{&}--bordered #{&}__title {
    @include utils.bs-media-breakpoint-down(md) {
      margin-bottom: 0;
    }
  }

  @at-root #{&}__subtitle {
    line-height: utils.f-rem-calc(22);

    @include utils.bs-media-breakpoint-up(md) {
      padding-right: utils.f-convert-to-rem(120);
    }
  }
}
</style>
